export default {
  headers: {
    from: 'מסכום',
    to: 'עד סכום',
    rate: 'עמלה %',
  },
  addTier: 'הוסף מדרגה',
  noLimit: 'ללא הגבלה',
  rateError: 'העמלה חייבת להיות גבוהה מהמדרגה הקודמת',
};
